export default __webpack_public_path__ + "sm_notebook_logo.dc8da118.png";